import React from 'react';

import { Body } from '@swyftx/aviary/atoms/Typography';
import { BodyProps } from '@swyftx/aviary/atoms/Typography/Body/Body.styles';
import { MarginPosition } from '@swyftx/margin/build/types';

import { observer } from 'mobx-react-lite';
import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';

type Props = {
  position: MarginPosition;
} & BodyProps;

const PositionInstrumentSymbol: React.FC<Props> = observer(({ position, ...rest }) => {
  const { getInstrumentSymbol, getMarketByPosition } = useMarginInstruments();

  const market = getMarketByPosition(position);

  if (!market) return null;

  return <Body {...rest}>{getInstrumentSymbol(market)}</Body>;
});

export { PositionInstrumentSymbol };
